// Here you write your query definition
// Each operation should have a specific file except dictionaries which have smaller definitions

import { gql } from "@apollo/client";
import Fragments from "../fragments";

export const MY_FIRST_QUERY = gql`
  query myFirstQuery {
    myFirstQuery {
      ...description
    }
  }
  ${Fragments.description}
`;
